module.exports = __webpack_public_path__ + "img/mn.aba956e9.jpg";